<template>
  <modal width="35" :show-modal="showModal" @close-modal="closeModal">
  
    <div class="delete-modal">
      <div class="flex justify-center">

        <handoff-svg />

      </div>
      <div class="my-6">
        <p>{{ type }} Completed</p>
      </div>
    </div>
  </modal>
</template>

<script>
import HandoffSvg from "../svgs/handoffSuccess.vue";

export default {
  props: {
    type: {
      type: String,
      required: false,
      default: "Hand-Off",
    },
    showModal: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
   components: {
    HandoffSvg,
  },
  methods: {
    // closeModal() {
    //    this.$emit("booking-action-completed");
    //     this.$emit("refetchBookings");
    //   this.$emit("close-modal");
    // },
       closeModal() {
      this.$emit("booking-action-completed");
      this.$emit("refetchBookings");
      this.$emit("close-modal");
    },
  },
};
</script>

<style scoped>
.delete-modal {
  text-align: center;
}
</style>
